<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-icon class="mx-4" v-else>fa-user</v-icon>
      <v-toolbar-title>Customer</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container fluid class="pa-0 grey lighten-2">
        <v-layout column>
          <v-flex>
            <Customer :id="id" :dialler="false"></Customer>
          </v-flex>
        </v-layout>
      </v-container>

      <v-speed-dial
        v-model="fab"
        fixed
        bottom
        right
        open-on-hover
        transition="slide-y-transition"
        v-if="!UserHasRole('Property Broker')"
      >
        <template v-slot:activator>
          <v-btn color="accent darken-1" dark fab v-model="fab">
            <v-icon v-if="fab">fas fa-times</v-icon>
            <v-icon v-else>fad fa-user-cog</v-icon>
          </v-btn>
        </template>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn fab small color="primary" dark @click.stop="showCustomerEdit = true" v-on="on">
              <v-icon small style="--fa-secondary-opacity: 1;--fa-secondary-color: green">fad fa-user-edit</v-icon>
            </v-btn>
          </template>
          <span>Edit Customer Details</span>
        </v-tooltip>
        <v-tooltip left v-if="UserHasRole('Platform')">
          <template v-slot:activator="{ on }">
            <v-btn fab small color="primary" dark @click.stop="toggleClosed()" v-on="on">
              <v-icon small v-if="customer.closed === true">fad fa-user</v-icon>
              <v-icon small v-else style="--fa-secondary-opacity: 1;--fa-secondary-color: red"
                >fad fa-user-times</v-icon
              >
            </v-btn>
          </template>
          <span v-if="customer.closed === true">Re-open customer</span>
          <span v-else>Close Customer</span>
        </v-tooltip>
        <v-tooltip left v-if="UserHasRole('Platform')">
          <template v-slot:activator="{ on }">
            <v-btn fab small color="primary" dark @click.stop="showDeleteDialog = true" v-on="on">
              <v-icon small>fad fa-user-slash</v-icon>
            </v-btn>
          </template>
          <span>Delete Customer</span>
        </v-tooltip>
      </v-speed-dial>
    </v-content>
    <customer-edit-dialog :customer="customer" :show.sync="showCustomerEdit"></customer-edit-dialog>
    <close-customer-dialog :customer="customer" :show.sync="showCloseDialog" :page="page"></close-customer-dialog>
    <delete-customer-dialog :customer="customer" :show.sync="showDeleteDialog" :page="page"></delete-customer-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import CustomerEditDialog from './CustomerRegistration/CustomerEditDialog';
import CloseCustomerDialog from './OverviewDrawer/Info/CloseCustomerDialog';
import DeleteCustomerDialog from './OverviewDrawer/Info/DeleteCustomerDialog';
import Customer from './Customer';

export default {
  name: 'CustomerPage',
  components: {
    Customer,
    CloseCustomerDialog,
    CustomerEditDialog,
    DeleteCustomerDialog
  },
  data: () => ({
    customerTab: null,
    fab: false,
    page: 'customer',
    showCloseDialog: false,
    showCustomerEdit: false,
    showDeleteDialog: false
  }),
  computed: {
    ...mapGetters([
      'LoadingCustomer',
      'SelectedCustomer',
      'UILeftDrawer',
      'UserHasRole',
      'JourneyTypes',
      'SelectedEnquiry',
      'SelectedPartner'
    ]),
    id() {
      return this.$route.params.id;
    },
    avatarUrl() {
      return `https://s3-eu-west-1.amazonaws.com/media.alternativebusinessfunding.co.uk/public/avatars/${this.customer.owner.id}.png`;
    },
    customer() {
      return this.SelectedCustomer;
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    showDetails: function() {
      if (this.UserHasRole('Provider') && !this.UserHasRole('Property Broker')) {
        return (
          this.SelectedEnquiry.customer.id === this.SelectedCustomer.id &&
          this.SelectedEnquiry.active === true &&
          this.SelectedEnquiry.status.name !== 'PENDING'
        );
      }
      return true;
    },
    isBankReferral() {
      return this.customer.referrer && this.customer.referrer.type === 'bank';
    },
    referrerAccountId() {
      return this.customer.referrer && this.customer.referrer.account_id;
    },
    excludedBusinesses() {
      if (this.SelectedPartner && this.SelectedPartner.excluded_businesses) {
        return this.SelectedPartner.excluded_businesses.map(business => business.id);
      } else {
        return [];
      }
    },
    activeJourney() {
      return _.isUndefined(this.SelectedCustomer.active_journey) ? '' : this.SelectedCustomer.active_journey.name;
    }
  },
  methods: {
    ...mapActions([
      'getActivity',
      'getFunderEnquiry',
      'getJourneyTypes',
      'getOwnersList',
      'selectCustomer',
      'updateCustomer',
      'updateCustomer',
      'updateUILeftDrawerState'
    ]),
    switchFlag: function(flag) {
      this.updateCustomer({
        id: this.customer.id,
        updates: {
          [flag]: !this.customer[flag]
        }
      });
    },
    toggleClosed: function() {
      if (this.customer.closed) {
        this.switchFlag('closed');
      } else {
        this.showCloseDialog = true;
      }
    },
    getCustomerActivity: function() {
      this.getActivity(this.$route.params.id);
    }
  },
  beforeMount() {
    if (this.UserHasRole('Provider') && !this.UserHasRole('Property Broker')) {
      if (_.isUndefined(this.$route.params.enquiryId)) {
        this.$router.push('/funders');
      } else if (_.isUndefined(this.SelectedEnquiry.customer)) {
        this.getFunderEnquiry(this.$route.params.enquiryId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-central-height {
  height: calc(100vh - 72px);
  max-height: calc(100vh - 72px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
